// LOCALES
export const LOCALES_SET_LANGUAGE = 'LOCALES::SET_LANGUAGE'
export const ROUTE_CHANGE = 'ROUTE_CHANGE'

// SEARCH
export const SEARCH_OPEN = 'SEARCH_OPEN'

// MENU
export const MENU_OPEN = 'MENU_OPEN'

// NEWSLETTER POPUP
// export const NEWSLETTER_POPUP = 'NEWSLETTER_POPUP'

// PRISMIC
export const FETCH_PRISMIC = 'FETCH_PRISMIC'
export const ACTIVE_DOC = 'ACTIVE_DOC'
export const PRISMIC_DATA = 'PRISMIC_DATA'

// GTM
export const NEWSLETTER_SIGNUP = 'NEWSLETTER_SIGNUP'
export const PROVINCE_CLICKED = 'PROVINCE_CLICKED'
export const AGE_GATE_COOKIE = 'AGE_GATE_COOKIE'
export const SOCIAL_CLICKED = 'SOCIAL_CLICKED'
export const LOCALE_SET_LANGUAGE = 'LOCALE_SET_LANGUAGE'



// WEBPACK FOOTER //
// ./src/redux/constants.js